import type { BaseDictionaryItem } from './dictionaryUtils'

/**
 * Interface for notification type items
 */
export interface NotificationTypeItem extends BaseDictionaryItem {
  /** Name of the notification type (used for matching) */
  name: string
  /** Default title for the notification */
  title: string
  /** Default description for the notification */
  description: string
  /** Icon to display in the avatar */
  avatarIcon: string
  /** Color for the avatar */
  avatarColor: string
  /** Router path to navigate to when clicked */
  path: string | null
  /** External URL to navigate to when clicked */
  url: string | null
}

/**
 * Dictionary of notification types with their default properties
 */
export const NOTIFICATION_TYPES: readonly NotificationTypeItem[] = [
  {
    key: 'Error',
    name: 'Error',
    label: 'Error Notification',
    title: 'Error Notification',
    description: 'Something went wrong',
    avatarIcon: 'alert-circle',
    avatarColor: 'error',
    path: null,
    url: null
  },
  {
    key: 'Success',
    name: 'Success',
    label: 'Success Notification',
    title: 'Success Notification',
    description: 'Action completed successfully',
    avatarIcon: 'check-circle',
    avatarColor: 'success',
    path: null,
    url: null
  },
  {
    key: 'Warning',
    name: 'Warning',
    label: 'Warning Notification',
    title: 'Warning Notification',
    description: 'Please review this action',
    avatarIcon: 'alert-triangle',
    avatarColor: 'warning',
    path: null,
    url: null
  },
  {
    key: 'Info',
    name: 'Info',
    label: 'Info Notification',
    title: 'Info Notification',
    description: 'Here is some information',
    avatarIcon: 'info',
    avatarColor: 'info',
    path: null,
    url: null
  },
  {
    key: 'todo-new_assigned',
    name: 'todo-new_assigned',
    label: 'New Task Assigned',
    title: 'New Task Assigned',
    description: 'A new task has been assigned to you',
    avatarIcon: 'clipboard-list',
    avatarColor: 'info',
    path: '/tasks',
    url: null
  },
  {
    key: 'target-hit',
    name: 'target-hit',
    label: 'Target Hit',
    title: 'Target Hit',
    description: 'Congratulations! You have hit your target',
    avatarIcon: 'target',
    avatarColor: 'success',
    path: null,
    url: null
  },
  {
    key: 'target-not_hit',
    name: 'target-not_hit',
    label: 'Target Not Hit',
    title: 'Target Not Hit',
    description: 'You have not hit your target',
    avatarIcon: 'target',
    avatarColor: 'warning',
    path: null,
    url: null
  }
] as const
